// ログインボーナス（7日周期・累計日数）の受け取り演出。
import { LOGIN_BONUS } from '@hyakki/core';
import { api } from '../api';
import { sfx } from '../audio';
import { act, state } from '../state';
import { rewardHtml } from './dom';
import { icon } from './icons';
import { openModal, toast } from './overlay';
import { errorText } from './status';

let showing = false;
export async function showLoginBonus() {
  const lb = state.me?.loginBonus;
  if (!lb || lb.claimedToday || showing) return;
  showing = true;
  setTimeout(() => (showing = false), 3000); // 同時に2回呼ばれても札は1枚
  const cycle: unknown[] = Array.isArray(lb.cycle) ? lb.cycle : LOGIN_BONUS.cycle;
  const n = cycle.length || 7;
  const day = lb.days + 1; // 今日受け取ると累計何日目か
  const today = ((day - 1) % n) + 1;
  const m = openModal(
    `<div class="lb">
      <p class="lb-lead">累計 <b>${day}</b> 日目のお礼です（連続でなくても進みます）</p>
      <ol class="lb-days">${Array.from({ length: n }, (_, i) => {
        const d = i + 1;
        const reward = d === today && lb.next ? lb.next : cycle[i];
        return `<li class="${d < today ? 'got' : d === today ? 'today' : ''}"><span class="lb-day">${d}日目</span><div class="lb-reward">${reward ? rewardHtml(reward) : ''}</div>${d < today ? `<i class="lb-stamp">${icon('check')}</i>` : ''}</li>`;
      }).join('')}</ol>
      <button class="btn primary wide lb-claim">受け取る</button>
    </div>`,
    { title: 'ログインボーナス', className: 'lb-modal' },
  );
  m.body.querySelector('.lb-claim')!.addEventListener('click', async (e) => {
    const b = e.currentTarget as HTMLButtonElement;
    b.disabled = true;
    try {
      await act(api.claimLoginBonus());
      m.body.querySelector('.lb-days li.today')?.insertAdjacentHTML('beforeend', `<i class="lb-stamp new">${icon('check')}</i>`);
      sfx('stamp');
      setTimeout(() => sfx('reward'), 260);
      b.textContent = '受け取りました';
      setTimeout(() => {
        m.close();
        toast('ログインボーナスを受け取りました', 'good');
      }, 1100);
    } catch (err) {
      b.disabled = false;
      toast(errorText(err), 'error');
    }
  });
}
